import './sass/main.scss';
import './js/modal.js';
import './js/pagination.js';
import './js/preloader.js';
import './js/searching-input-dropdown.js';
import './js/theme-mode.js';

import '@pnotify/core/dist/PNotify.css';
import '@pnotify/mobile/dist/PNotifyMobile.css';
import '@pnotify/core/dist/BrightTheme.css';
import '@pnotify/core/dist/Material.css';
